import React, {Component} from "react";
import Tile from '../Tile/Tile';
import fontsData from './assets/fontsData'

class Content extends Component {
  constructor(props) {
    super(props);

    this.state = {
      placeholder: "Keith",
    };
  }

  handleInputChange = event => {
    let val = event.target.value;
    const name = event.target.name;

    if (name === "placeholder") {
      val = val.substring(0, 30);
    }
    this.setState({
      [name]: val
    });
  };

  render() {
    return (
      <div className="content-wrapper text-center">
        <div className="row">
          <div className="col-md-6 offset-md-3">
            <form className="form-group">
              <label htmlFor="font-check" className="label">Enter Your Name:</label>
              <input id="font-check" value={this.state.placeholder} name="placeholder" onChange={this.handleInputChange}
                     type="text" placeholder="placeholder" className="form-control"/>
            </form>
          </div>
        </div>
        <div className="row">
            <div className="col-md-6 offset-md-3 pb-3">
                <h5 className="Disclaimer">Disclaimer:</h5>
                <p className="Disclaimer">Your name sign may vary depending on the font type. The letters may be attached to each other and their lines may be thickened differently than what is shown in the preview in order to increase the stability of the design. All names are cut with a capital first letter unless otherwise specified by the customer.
                </p>
            </div>
        </div>
        <div className="row">
          {fontsData.fonts.map((font, i) => (
            <div key={i} className="col-sm-12 col-md-6 col-lg-6">
              <div className="row">
                <Tile
                  url={font.url}
                  font={font.font}
                  fontName={font.fontName}
                  inputText={this.state.placeholder}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Content;


// WEBPACK FOOTER //
// ./src/app/Content/Content.js